import React, { useEffect, useState, useRef } from "react";
import DataTable from "react-data-table-component";
import axios from "axios";
import { Spinner, Button, Modal } from "react-bootstrap";
import { userTableCustomStyles } from "../../../utils/TableCustomStyles";
import { toast, ToastContainer } from "react-toastify";

const ExpandableTerminalComponent = (props) => {
  const addterminalvendorform = useRef(null);
  const addterminalparameterform = useRef(null);
  const addterminalexpenseform = useRef(null);
  const [loading, setLoading] = useState(true);
  const [vendorData, setVendorData] = useState([]);
  const [paramData, setParamData] = useState([]);
  const [expenseData, setExpenseData] = useState([]);
  
  const chargeData = props.chargeData
  const containerData = props.containerData
  const currencyData = props.currencyData
  const countryData = props.countryData


  useEffect(() => {
    const fetchData = async () => {
      try {
        const terminal_id = props.data.id;

        const [vendorRes, paramRes, expenseRes] = await Promise.all([
          axios.get(`${process.env.REACT_APP_BACKEND_API_URL}/user/terminalvendor/?terminal=${terminal_id}`),
          axios.get(`${process.env.REACT_APP_BACKEND_API_URL}/user/terminalparameter/?terminal=${terminal_id}`),
          axios.get(`${process.env.REACT_APP_BACKEND_API_URL}/user/terminalexpense/?terminal=${terminal_id}`),
        ]);

        setVendorData(vendorRes.data);
        setParamData(paramRes.data);
        setExpenseData(expenseRes.data);
      } catch (err) {
        console.error("Error fetching terminal details:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [props.data.id]);


  const fetchTerminalData = async (props) => {
    try {
      const terminal_id = props.data.id;

      const [vendorRes, paramRes, expenseRes] = await Promise.all([
        axios.get(`${process.env.REACT_APP_BACKEND_API_URL}/user/terminalvendor/?terminal=${terminal_id}`),
        axios.get(`${process.env.REACT_APP_BACKEND_API_URL}/user/terminalparameter/?terminal=${terminal_id}`),
        axios.get(`${process.env.REACT_APP_BACKEND_API_URL}/user/terminalexpense/?terminal=${terminal_id}`),
      ]);

      setVendorData(vendorRes.data);
      setParamData(paramRes.data);
      setExpenseData(expenseRes.data);
    } catch (err) {
      console.error("Error fetching terminal details:", err);
    } finally {
      setLoading(false);
    }
  };

  // --------------------------------------- Terminal Vendor ------------------------------
  const terminalVendorColumns = [
    { name: "Name", width: '150px', selector: (row) => row.name, sortable: true},
    { name: "Company", width: '150px', selector: (row) => row.company, sortable: true },
    { name: "Address", width: '350px', selector: (row) => <div className="text-left">
                                            <span>{row.address_line_1}, {row.address_line_2}</span><br></br>
                                            <span>{row.city} - {row.pincode}</span><br></br>
                                            <span>{row.state}, {row.country_data?.long_name}</span>
                                          </div>, sortable: true },
    { name: "Contact", width: '200px', selector: (row) => <div className="text-left">
                                            <span><b>Email:</b> {row.email}</span><br></br>
                                            <span><b>Mobile:</b> {row.mobile_number}</span>
                                          </div>, sortable: true },
    { name: "Ids", width: '200px', selector: (row) => <div className="text-left">
                                        <span><b>License:</b> {row.license_number}</span><br></br>
                                        <span><b>GST:</b> {row.gst_number}</span><br></br>
                                        <span><b>PAN:</b> {row.pan_number}</span>
                                      </div>, sortable: true },
    {
      name: "Action",
      width: '110px',
      center: true,
      cell: (row) => (
        <div>
          <Button className="btn btn-sm btn-inox-green border-0" onClick={() => handleTerminalVendor(row)}>
            <i className="fa fa-edit"></i>
          </Button>
          <Button className="btn btn-sm bg-danger border-0 mx-2" onClick={() => handleDeleteTerminalVendor(row)}>
            <i className="fa fa-trash"></i>
          </Button>
        </div>
      ),
    },
  ];

  
  const [showAddTerminalVendorForm, setShowAddTerminalVendorForm] = useState(false);
  const [showUpdateTerminalVendorForm, setShowUpdateTerminalVendorForm] = useState(false);
  const [showAddTerminalVendorLoader, setShowAddTerminalVendorLoader] = useState(false);
  const [showUpdateTerminalVendorLoader, setShowUpdateTerminalVendorLoader] = useState(false);
  const [enableAddTerminalVendor, setEnableAddTerminalVendor] = useState(false);
  const [enableUpdateTerminalVendor, setEnableUpdateTerminalVendor] = useState(false);
  const [showDeleteTerminalVendorModal, setShowDeleteTerminalVendorModal] = useState(false);
  const [showDeleteTerminalVendorLoader, setShowDeleteTerminalVendorLoader] = useState(false);

  const [vendorName, setVendorName] = useState("");
  const [vendorCompany, setVendorCompany] = useState("");
  const [vendorAddressLine1, setVendorAddressLine1] = useState("");
  const [vendorAddressLine2, setVendorAddressLine2] = useState("");
  const [vendorCity, setVendorCity] = useState("");
  const [vendorState, setVendorState] = useState("");
  const [vendorCountry, setVendorCountry] = useState("");
  const [vendorPincode, setVendorPincode] = useState("");
  const [vendorEmail, setVendorEmail] = useState("");
  const [vendorLicenseNumber, setVendorLicenseNumber] = useState("");
  const [vendorMobileNumber, setVendorMobileNumber] = useState("");
  const [vendorGstNumber, setVendorGstNumber] = useState("");
  const [vendorPanNumber, setVendorPanNumber] = useState("");
  
  const [showVendorNameError, setShowVendorNameError] = useState("");
  const [showVendorCompanyError, setShowVendorCompanyError] = useState("");
  const [showVendorAddressLine1Error, setShowVendorAddressLine1Error] = useState("");
  const [showVendorCityError, setShowVendorCityError] = useState("");
  const [showVendorStateError, setShowVendorStateError] = useState("");
  const [showVendorCountryError, setShowVendorCountryError] = useState("");
  const [showVendorPincodeError, setShowVendorPincodeError] = useState("");
  const [showVendorEmailError, setShowVendorEmailError] = useState("");
  const [showVendorLicenseNumberError, setShowVendorLicenseNumberError] = useState("");
  const [showVendorMobileNumberError, setShowVendorMobileNumberError] = useState("");
  const [showVendorGstNumberError, setShowVendorGstNumberError] = useState("");
  const [showVendorPanNumberError, setShowVendorPanNumberError] = useState("");

  const [updateVendorId, setUpdateVendorId] = useState("");
  const [updateVendorName, setUpdateVendorName] = useState("");
  const [updateVendorCompany, setUpdateVendorCompany] = useState("");
  const [updateVendorAddressLine1, setUpdateVendorAddressLine1] = useState("");
  const [updateVendorAddressLine2, setUpdateVendorAddressLine2] = useState("");
  const [updateVendorCity, setUpdateVendorCity] = useState("");
  const [updateVendorState, setUpdateVendorState] = useState("");
  const [updateVendorCountry, setUpdateVendorCountry] = useState("");
  const [updateVendorPincode, setUpdateVendorPincode] = useState("");
  const [updateVendorEmail, setUpdateVendorEmail] = useState("");
  const [updateVendorLicenseNumber, setUpdateVendorLicenseNumber] = useState("");
  const [updateVendorMobileNumber, setUpdateVendorMobileNumber] = useState("");
  const [updateVendorGstNumber, setUpdateVendorGstNumber] = useState("");
  const [updateVendorPanNumber, setUpdateVendorPanNumber] = useState("");

  const [showUpdateVendorNameError, setShowUpdateVendorNameError] = useState("");
  const [showUpdateVendorCompanyError, setShowUpdateVendorCompanyError] = useState("");
  const [showUpdateVendorAddressLine1Error, setShowUpdateVendorAddressLine1Error] = useState("");
  const [showUpdateVendorCityError, setShowUpdateVendorCityError] = useState("");
  const [showUpdateVendorStateError, setShowUpdateVendorStateError] = useState("");
  const [showUpdateVendorCountryError, setShowUpdateVendorCountryError] = useState("");
  const [showUpdateVendorPincodeError, setShowUpdateVendorPincodeError] = useState("");
  const [showUpdateVendorEmailError, setShowUpdateVendorEmailError] = useState("");
  const [showUpdateVendorLicenseNumberError, setShowUpdateVendorLicenseNumberError] = useState("");
  const [showUpdateVendorMobileNumberError, setShowUpdateVendorMobileNumberError] = useState("");
  const [showUpdateVendorGstNumberError, setShowUpdateVendorGstNumberError] = useState("");
  const [showUpdateVendorPanNumberError, setShowUpdateVendorPanNumberError] = useState("");


  const handleTerminalVendor = (data) => {
    setShowAddTerminalVendorForm(false)
    setShowUpdateTerminalVendorForm(true)
    setUpdateVendorId(data?.id)
    setUpdateVendorName(data?.name)
    setUpdateVendorCompany(data?.company)
    setUpdateVendorAddressLine1(data?.address_line_1)
    setUpdateVendorAddressLine2(data?.address_line_2)
    setUpdateVendorCity(data?.city)
    setUpdateVendorState(data?.state)
    setUpdateVendorCountry(data?.country_data?.id)
    setUpdateVendorPincode(data?.pincode)
    setUpdateVendorEmail(data?.email)
    setUpdateVendorLicenseNumber(data?.license_number)
    setUpdateVendorMobileNumber(data?.mobile_number)
    setUpdateVendorGstNumber(data?.gst_number)
    setUpdateVendorPanNumber(data?.pan_number)
  }

  const handleDeleteTerminalVendor = (data) => {
    setUpdateVendorId(data?.id)
    setShowDeleteTerminalVendorModal(true)
  }

  const handleAddTerminalVendorForm = () => {
    setShowAddTerminalVendorForm(true)
    setShowUpdateTerminalVendorForm(false)
    setVendorName("")
    setVendorCompany("")
    setVendorAddressLine1("")
    setVendorAddressLine2("")
    setVendorCity("")
    setVendorState("")
    setVendorCountry("")
    setVendorPincode("")
    setVendorEmail("")
    setVendorLicenseNumber("")
    setVendorMobileNumber("")
    setVendorGstNumber("")
    setVendorPanNumber("")
  }

  const handleCloseTerminalVendorForm = () => {
    setShowAddTerminalVendorForm(false)
    setShowUpdateTerminalVendorForm(false)
    setVendorName("")
    setVendorCompany("")
    setVendorAddressLine1("")
    setVendorAddressLine2("")
    setVendorCity("")
    setVendorState("")
    setVendorCountry("")
    setVendorPincode("")
    setVendorEmail("")
    setVendorLicenseNumber("")
    setVendorMobileNumber("")
    setVendorGstNumber("")
    setVendorPanNumber("")
  }

  useEffect(() => {
    if(vendorName != "" && vendorCompany != "" && vendorAddressLine1 != "" && vendorCity != "" && vendorState != "" && 
      vendorCountry != "" && vendorPincode != "" && vendorEmail != "" && vendorLicenseNumber != "" && vendorMobileNumber != "" && 
      vendorGstNumber != "" && vendorPanNumber != ""){
      setEnableAddTerminalVendor(true)
    }
    else{
      setEnableAddTerminalVendor(false)
    } 
  }, [vendorName, vendorCompany, vendorAddressLine1, vendorCity, vendorState, vendorCountry, vendorPincode, vendorEmail, vendorLicenseNumber, 
    vendorMobileNumber, vendorGstNumber, vendorPanNumber]);

  const addNewTerminalVendor = async (e) => {
    e.preventDefault();
    setShowAddTerminalVendorLoader(true)

    const data = {
      terminal: props.data.id,
      name: addterminalvendorform.current.name.value,
      company: addterminalvendorform.current.company.value,
      address_line_1: addterminalvendorform.current.address_line_1.value,
      address_line_2: addterminalvendorform.current.address_line_2.value,
      city: addterminalvendorform.current.city.value,
      state: addterminalvendorform.current.state.value,
      country: addterminalvendorform.current.country.value,
      pincode: addterminalvendorform.current.pincode.value,
      email: addterminalvendorform.current.email.value,
      license_number: addterminalvendorform.current.license_number.value,
      mobile_number: addterminalvendorform.current.mobile_number.value,
      gst_number: addterminalvendorform.current.gst_number.value,
      pan_number: addterminalvendorform.current.pan_number.value,
      created_by: JSON.stringify(props.loggedInUser)
    }

    const response = await axios.post(process.env.REACT_APP_BACKEND_API_URL+'/user/terminalvendor/', data,  
      {
        headers: { 'content-type': 'application/json'}
      }
    );

    if (response.status === 200 ) {
      toast.success("Terminal Vendor Created Successfully")
    }

    addterminalvendorform.current.name.value = ""
    addterminalvendorform.current.company.value = ""
    addterminalvendorform.current.address_line_1.value = ""
    addterminalvendorform.current.address_line_2.value = ""
    addterminalvendorform.current.city.value = ""
    addterminalvendorform.current.state.value = ""
    addterminalvendorform.current.country.value = ""
    addterminalvendorform.current.pincode.value = ""
    addterminalvendorform.current.email.value = ""
    addterminalvendorform.current.license_number.value = ""
    addterminalvendorform.current.mobile_number.value = ""
    addterminalvendorform.current.gst_number.value = ""
    addterminalvendorform.current.pan_number.value = ""

    fetchTerminalData(props)
    setShowUpdateTerminalVendorForm(false)
    setVendorName("")
    setVendorCompany("")
    setVendorAddressLine1("")
    setVendorAddressLine2("")
    setVendorCity("")
    setVendorState("")
    setVendorCountry("")
    setVendorPincode("")
    setVendorEmail("")
    setVendorLicenseNumber("")
    setVendorMobileNumber("")
    setVendorGstNumber("")
    setVendorPanNumber("")
    setShowAddTerminalVendorLoader(false)
    setShowAddTerminalVendorForm(false)
    setShowUpdateTerminalVendorForm(false)
  }

  useEffect(() => {
    if(updateVendorName != "" && updateVendorCompany != "" && updateVendorAddressLine1 != "" && updateVendorCity != "" && updateVendorState != "" && 
      updateVendorCountry != "" && updateVendorPincode != "" && updateVendorEmail != "" && updateVendorLicenseNumber != "" && updateVendorMobileNumber != "" && 
      updateVendorGstNumber != "" && updateVendorPanNumber != ""){
      setEnableUpdateTerminalVendor(true)
    }
    else{
      setEnableUpdateTerminalVendor(false)
    } 
  }, [updateVendorName, updateVendorCompany, updateVendorAddressLine1, updateVendorCity, updateVendorState, updateVendorCountry, updateVendorPincode, updateVendorEmail, updateVendorLicenseNumber, 
    updateVendorMobileNumber, updateVendorGstNumber, updateVendorPanNumber]);

  const updateTerminalVendor = async (e) => {
    e.preventDefault();
    setShowUpdateTerminalVendorLoader(true)

    const id = updateVendorId

    const data = {      
      name: updateVendorName,
      company: updateVendorCompany,
      address_line_1: updateVendorAddressLine1,
      address_line_2: updateVendorAddressLine2,
      city: updateVendorCity,
      state: updateVendorState,
      country: updateVendorCountry,
      pincode: updateVendorPincode,
      email: updateVendorEmail,
      license_number: updateVendorLicenseNumber,
      mobile_number: updateVendorMobileNumber,
      gst_number: updateVendorGstNumber,
      pan_number: updateVendorPanNumber,
      modified_by: JSON.stringify(props.loggedInUser)
    }

    const response = await axios.put(process.env.REACT_APP_BACKEND_API_URL+'/user/terminalvendor/'+id+'/', data,  
      {
        headers: { 'content-type': 'application/json'}
      }
    );

    if (response.status === 200 ) {
      toast.success("Terminal Updated Successfully")
      setUpdateVendorName("")
      setUpdateVendorCompany("")
      setUpdateVendorAddressLine1("")
      setUpdateVendorAddressLine2("")
      setUpdateVendorCity("")
      setUpdateVendorState("")
      setUpdateVendorCountry("")
      setUpdateVendorPincode("")
      setUpdateVendorEmail("")
      setUpdateVendorLicenseNumber("")
      setUpdateVendorMobileNumber("")
      setUpdateVendorGstNumber("")
      setUpdateVendorPanNumber("")
    }

    setShowUpdateTerminalVendorForm(false)
    fetchTerminalData(props)
    setShowUpdateTerminalVendorLoader(false)    
  }

  const deleteTerminalVendor = async (id) => {
    setShowDeleteTerminalVendorLoader(true)
    try {
        await axios.delete(process.env.REACT_APP_BACKEND_API_URL+'/user/terminalvendor/'+id+'/');
        setShowDeleteTerminalVendorModal(false)
        toast.success("Record deleted successfully")
    } catch (err) {
        toast.error("Error in deleting record! Try again.");
    }
    fetchTerminalData(props)
    setShowDeleteTerminalVendorLoader(false)
    setShowDeleteTerminalVendorModal(false)
  }

  // --------------------------------------- Terminal Parameter ------------------------------

  const terminalParamColumns = [
    { name: "Name", selector: (row) => row.name?.replaceAll("_"," "), sortable: true, width: "100px" },
    { name: "Cargo Type", selector: (row) => row.cargo_type? row.cargo_type.replaceAll("_", " "):"", sortable: true },
    { name: "Container", selector: (row) => row.product_data?.product_name, sortable: true },
    { name: "Trade Type", selector: (row) => row.trade_type, sortable: true },
    { name: "In/Out Mode", selector: (row) => row.terminal_in_out_mode, sortable: true },
    { name: "Free Days", selector: (row) => row.param_value, sortable: true, width: "110px" },
    { name: "Status", selector: (row) => row.status, sortable: true, width: "90px" },
    {
      name: "Action",
      center: true,
      cell: (row) => (
        <div>
          <Button className="btn btn-sm btn-inox-green border-0" onClick={() => handleTerminalParameter(row)}>
            <i className="fa fa-edit"></i>
          </Button>
          <Button className="btn btn-sm bg-danger border-0 mx-2" onClick={() => handleDeleteTerminalParameter(row)}>
            <i className="fa fa-trash"></i>
          </Button>
        </div>
      ),
    },
  ];


  const [showAddTerminalParameterForm, setShowAddTerminalParameterForm] = useState(false);
  const [showUpdateTerminalParameterForm, setShowUpdateTerminalParameterForm] = useState(false);
  const [showAddTerminalParameterLoader, setShowAddTerminalParameterLoader] = useState(false);
  const [showUpdateTerminalParameterLoader, setShowUpdateTerminalParameterLoader] = useState(false);
  const [enableAddTerminalParameter, setEnableAddTerminalParameter] = useState(false);
  const [enableUpdateTerminalParameter, setEnableUpdateTerminalParameter] = useState(false);
  const [showDeleteTerminalParameterModal, setShowDeleteTerminalParameterModal] = useState(false);
  const [showDeleteTerminalParameterLoader, setShowDeleteTerminalParameterLoader] = useState(false);

  const [parameterName, setParameterName] = useState("");
  const [parameterContainer, setParameterContainer] = useState("");
  const [parameterCargoType, setParameterCargoType] = useState("");
  const [parameterTradeType, setParameterTradeType] = useState("");
  const [parameterInOutMode, setParameterInOutMode] = useState("");
  const [parameterFreeDays, setParameterFreeDays] = useState(0);
  const [parameterStatus, setParameterStatus] = useState("ACTIVE");
  
  const [showParameterNameError, setShowParameterNameError] = useState(false);
  const [showParameterContainerError, setShowParameterContainerError] = useState(false);
  const [showParameterCargoTypeError, setShowParameterCargoTypeError] = useState(false);
  const [showParameterTradeTypeError, setShowParameterTradeTypeError] = useState(false);
  const [showParameterInOutModeError, setShowParameterInOutModeError] = useState(false);
  const [showParameterFreeDaysError, setShowParameterFreeDaysError] = useState(false);

  const [showUpdateParameterNameError, setShowUpdateParameterNameError] = useState(false);
  const [showUpdateParameterContainerError, setShowUpdateParameterContainerError] = useState(false);
  const [showUpdateParameterCargoTypeError, setShowUpdateParameterCargoTypeError] = useState(false);
  const [showUpdateParameterTradeTypeError, setShowUpdateParameterTradeTypeError] = useState(false);
  const [showUpdateParameterInOutModeError, setShowUpdateParameterInOutModeError] = useState(false);
  const [showUpdateParameterFreeDaysError, setShowUpdateParameterFreeDaysError] = useState(false);

  const [updateParameterId, setUpdateParameterId] = useState("");
  const [updateParameterName, setUpdateParameterName] = useState("");
  const [updateParameterContainer, setUpdateParameterContainer] = useState("");
  const [updateParameterCargoType, setUpdateParameterCargoType] = useState("");
  const [updateParameterTradeType, setUpdateParameterTradeType] = useState("");
  const [updateParameterInOutMode, setUpdateParameterInOutMode] = useState("");
  const [updateParameterFreeDays, setUpdateParameterFreeDays] = useState(0);
  const [updateParameterStatus, setUpdateParameterStatus] = useState("ACTIVE");

  const handleTerminalParameter = (data) => {
    setShowAddTerminalParameterForm(false)
    setShowUpdateTerminalParameterForm(true)
    setUpdateParameterId(data?.id)
    setUpdateParameterName(data.name)
    setUpdateParameterContainer(data.product_data?.id)
    setUpdateParameterCargoType(data.cargo_type)
    setUpdateParameterTradeType(data.trade_type)
    setUpdateParameterInOutMode(data.terminal_in_out_mode)
    setUpdateParameterFreeDays(data.param_value)
    setUpdateStatus(data.status)
  }

  const handleDeleteTerminalParameter = (data) => {
    setUpdateParameterId(data?.id)
    setShowDeleteTerminalParameterModal(true)
  }

  const handleAddTerminalParameterForm = () => {
    setShowAddTerminalParameterForm(true)
    setShowUpdateTerminalParameterForm(false)
    setParameterName("");
    setParameterContainer("");
    setParameterCargoType("");
    setParameterTradeType("");
    setParameterInOutMode("");
    setParameterFreeDays(0);
    setParameterStatus("ACTIVE")
  }

  const handleCloseTerminalParameterForm = () => {
    setShowAddTerminalParameterForm(false)
    setShowUpdateTerminalParameterForm(false)
    setParameterName("");
    setParameterContainer("");
    setParameterCargoType("");
    setParameterTradeType("");
    setParameterInOutMode("");
    setParameterFreeDays(0);
    setParameterStatus("ACTIVE")
  }

  
  useEffect(() => {
    if(parameterName != "" && parameterContainer != "" && parameterCargoType != "" && parameterTradeType != "" && parameterInOutMode != "" && parameterFreeDays != ""){
      setEnableAddTerminalParameter(true)
    }
    else{
      setEnableAddTerminalParameter(false)
    } 
  }, [parameterName, parameterContainer, parameterCargoType, parameterTradeType, parameterInOutMode, parameterFreeDays]);

  const addNewTerminalParameter = async (e) => {
    e.preventDefault();
    setShowAddTerminalParameterLoader(true)

    const data = {
      terminal: props.data.id,
      name: addterminalparameterform.current.name.value,
      product: addterminalparameterform.current.container.value,
      cargo_type: addterminalparameterform.current.cargo_type.value,
      trade_type: addterminalparameterform.current.trade_type.value,
      terminal_in_out_mode: addterminalparameterform.current.terminal_in_out_mode.value,
      param_value: addterminalparameterform.current.free_days.value,
      status: addterminalparameterform.current.status.value,
      created_by: JSON.stringify(props.loggedInUser)
    }

    const response = await axios.post(process.env.REACT_APP_BACKEND_API_URL+'/user/terminalparameter/', data,  
      {
        headers: { 'content-type': 'application/json'}
      }
    );

    if (response.status === 200 ) {
      toast.success("Terminal Parameter Created Successfully")
    }

    addterminalparameterform.current.name.value = ""
    addterminalparameterform.current.container.value = ""
    addterminalparameterform.current.cargo_type.value = ""
    addterminalparameterform.current.trade_type.value = ""
    addterminalparameterform.current.terminal_in_out_mode.value = ""
    addterminalparameterform.current.free_days.value = ""
    addterminalparameterform.current.status.value = "ACTIVE"

    fetchTerminalData(props)
    setShowUpdateTerminalParameterForm(false)
    setParameterName("");
    setExpenseContainer("");
    setParameterCargoType("");
    setParameterTradeType("");
    setParameterInOutMode("");
    setParameterFreeDays(0);
    setStatus("ACTIVE")
    setShowAddTerminalParameterLoader(false)
  }

  useEffect(() => {
    if(updateParameterName != "" && updateParameterContainer != "" && updateParameterCargoType != "" && updateParameterTradeType != "" && updateParameterInOutMode != "" && updateParameterFreeDays != ""){
      setEnableUpdateTerminalParameter(true)
    }
    else{
      setEnableUpdateTerminalParameter(false)
    } 
  }, [updateParameterName, updateParameterContainer, updateParameterCargoType, updateParameterTradeType, updateParameterInOutMode, updateParameterFreeDays]);

  const updateTerminalParameter = async (e) => {
    e.preventDefault();
    setShowUpdateTerminalParameterLoader(true)

    const id = updateParameterId

    const data = {
      name: updateParameterName,
      product: updateParameterContainer,
      cargo_type: updateParameterCargoType,
      trade_type: updateParameterTradeType,
      terminal_in_out_mode: updateParameterInOutMode,
      param_value: updateParameterFreeDays,
      status: updateParameterStatus,
      modified_by: JSON.stringify(props.loggedInUser)
    }

    const response = await axios.put(process.env.REACT_APP_BACKEND_API_URL+'/user/terminalparameter/'+id+'/', data,  
      {
        headers: { 'content-type': 'application/json'}
      }
    );

    if (response.status === 200 ) {
      toast.success("Terminal Parameter Updated Successfully")
      setUpdateParameterName("")
      setUpdateParameterContainer("")
      setUpdateParameterCargoType("");
      setUpdateParameterTradeType("");
      setUpdateParameterInOutMode("");
      setUpdateParameterFreeDays("")
      setUpdateParameterStatus("ACTIVE")
    }

    setShowUpdateTerminalParameterForm(false)
    fetchTerminalData(props)
    setShowUpdateTerminalParameterLoader(false)    
  }

  const deleteTerminalParameter = async (id) => {
    setShowDeleteTerminalParameterLoader(true)
    try {
        await axios.delete(process.env.REACT_APP_BACKEND_API_URL+'/user/terminalparameter/'+id+'/');
        setShowDeleteTerminalParameterModal(false)
        toast.success("Record deleted successfully")
    } catch (err) {
        toast.error("Error in deleting record! Try again.");
    }
    fetchTerminalData(props)
    setShowDeleteTerminalParameterLoader(false)
    setShowDeleteTerminalParameterModal(false)
  }

  // --------------------------------------- Terminal Expense ------------------------------

  const terminalExpenseColumns = [
    { name: "Charge", selector: (row) => row.charge_data?.name, sortable: true },
    { name: "Container", selector: (row) => row.product_data?.product_name, sortable: true },
    { name: "Collection", selector: (row) => row.currency_data?.symbol +" "+ row.collection, sortable: true },
    { name: "Expense", selector: (row) => row.currency_data?.symbol +" "+ row.expense, sortable: true },
    { name: "Is Default", selector: (row) => row.default_charge, sortable: true },
    { name: "Status", selector: (row) => row.status, sortable: true },
    {
      name: "Action",
      center: true,
      cell: (row) => (
        <div>
          <Button className="btn btn-sm btn-inox-green border-0" onClick={() => handleTerminalExpense(row)}>
            <i className="fa fa-edit"></i>
          </Button>
          <Button className="btn btn-sm bg-danger border-0 mx-2" onClick={() => handleDeleteTerminalExpense(row)}>
            <i className="fa fa-trash"></i>
          </Button>
        </div>
      ),
    },
  ];


  
  const [showAddTerminalExpenseForm, setShowAddTerminalExpenseForm] = useState(false);
  const [showUpdateTerminalExpenseForm, setShowUpdateTerminalExpenseForm] = useState(false);
  const [showAddTerminalExpenseLoader, setShowAddTerminalExpenseLoader] = useState(false);
  const [showUpdateTerminalExpenseLoader, setShowUpdateTerminalExpenseLoader] = useState(false);
  const [enableAddTerminalExpense, setEnableAddTerminalExpense] = useState(false);
  const [enableUpdateTerminalExpense, setEnableUpdateTerminalExpense] = useState(false);
  const [showDeleteTerminalExpenseModal, setShowDeleteTerminalExpenseModal] = useState(false);
  const [showDeleteTerminalExpenseLoader, setShowDeleteTerminalExpenseLoader] = useState(false);

  const [expenseCharge, setExpenseCharge] = useState("");
  const [expenseContainer, setExpenseContainer] = useState("");
  const [expenseCollection, setExpenseCollection] = useState(0);
  const [expense, setExpense] = useState(0);
  const [expenseCurrency, setExpenseCurrency] = useState("");
  const [isDefault, setIsDefault] = useState("NO");
  const [status, setStatus] = useState("ACTIVE");
  
  const [showExpenseChargeError, setShowExpenseChargeError] = useState(false);
  const [showExpenseContainerError, setShowExpenseContainerError] = useState(false);
  const [showExpenseCollectionError, setShowExpenseCollectionError] = useState(false);
  const [showExpenseCurrencyError, setShowExpenseCurrencyError] = useState(false);
  const [showExpenseError, setShowExpenseError] = useState(false);

  const [showUpdateExpenseChargeError, setShowUpdateExpenseChargeError] = useState(false);
  const [showUpdateExpenseContainerError, setShowUpdateExpenseContainerError] = useState(false);
  const [showUpdateExpenseCollectionError, setShowUpdateExpenseCollectionError] = useState(false);
  const [showUpdateExpenseError, setShowUpdateExpenseError] = useState(false);
  const [showUpdateExpenseCurrencyError, setShowUpdateExpenseCurrencyError] = useState(false);

  const [updateExpenseId, setUpdateExpenseId] = useState("");
  const [updateExpenseCharge, setUpdateExpenseCharge] = useState("");
  const [updateExpenseContainer, setUpdateExpenseContainer] = useState("");
  const [updateExpenseCollection, setUpdateExpenseCollection] = useState(0);
  const [updateExpense, setUpdateExpense] = useState(0);
  const [updateExpenseCurrency, setUpdateExpenseCurrency] = useState("");
  const [updateIsDefault, setUpdateIsDefault] = useState("NO");
  const [updateStatus, setUpdateStatus] = useState("ACTIVE");

  const handleTerminalExpense = (data) => {
    setShowAddTerminalExpenseForm(false)
    setShowUpdateTerminalExpenseForm(true)
    setUpdateExpenseId(data?.id)
    setUpdateExpenseCharge(data.charge_data?.id)
    setUpdateExpenseContainer(data.product_data?.id)
    setUpdateExpenseCollection(data.collection)
    setUpdateExpense(data.expense)
    setUpdateExpenseCurrency(data.currency_data?.id)
    setUpdateIsDefault(data.is_default)
    setUpdateStatus(data.status)
  }

  const handleDeleteTerminalExpense = (data) => {
    setUpdateExpenseId(data?.id)
    setShowDeleteTerminalExpenseModal(true)
  }

  const handleAddTerminalExpenseForm = () => {
    setShowAddTerminalExpenseForm(true)
    setShowUpdateTerminalExpenseForm(false)
    setExpenseCharge("");
    setExpenseContainer("");
    setExpenseCollection(0);
    setExpense(0);
    setExpenseCurrency("");
    setIsDefault("NO");
    setStatus("ACTIVE")
  }

  const handleCloseTerminalExpenseForm = () => {
    setShowAddTerminalExpenseForm(false)
    setShowUpdateTerminalExpenseForm(false)
    setExpenseCharge("");
    setExpenseContainer("");
    setExpenseCollection(0);
    setExpense(0);
    setExpenseCurrency("");
    setIsDefault("NO");
    setStatus("ACTIVE")
  }

  
  useEffect(() => {
    if(expenseCharge != "" && expenseContainer != "" && expenseCurrency != "" && expenseCollection != "" && expense != ""){
      setEnableAddTerminalExpense(true)
    }
    else{
      setEnableAddTerminalExpense(false)
    } 
  }, [expenseCharge, expenseContainer, expenseCurrency, expenseCollection, expense]);

  const addNewTerminalExpense = async (e) => {
    e.preventDefault();
    setShowAddTerminalExpenseLoader(true)

    const data = {
      terminal: props.data.id,
      charge: addterminalexpenseform.current.charge.value,
      product: addterminalexpenseform.current.container.value,
      currency: addterminalexpenseform.current.currency.value,
      collection: addterminalexpenseform.current.collection.value,
      expense: addterminalexpenseform.current.expense.value,
      default_charge: addterminalexpenseform.current.is_default_expense.value,
      status: addterminalexpenseform.current.status.value,
      created_by: JSON.stringify(props.loggedInUser)
    }

    const response = await axios.post(process.env.REACT_APP_BACKEND_API_URL+'/user/terminalexpense/', data,  
      {
        headers: { 'content-type': 'application/json'}
      }
    );

    if (response.status === 200 ) {
      toast.success("Terminal Expense Created Successfully")
    }

    addterminalexpenseform.current.charge.value = ""
    addterminalexpenseform.current.container.value = ""
    addterminalexpenseform.current.currency.value = ""
    addterminalexpenseform.current.collection.value = 0
    addterminalexpenseform.current.expense.value = 0
    addterminalexpenseform.current.is_default_expense.value = "NO"
    addterminalexpenseform.current.status.value = "ACTIVE"

    fetchTerminalData(props)
    setShowUpdateTerminalExpenseForm(false)
    setExpenseCharge("");
    setExpenseContainer("");
    setExpenseCollection(0);
    setExpense(0);
    setExpenseCurrency("");
    setIsDefault("NO");
    setStatus("ACTIVE")
    setShowAddTerminalExpenseLoader(false)
  }

  useEffect(() => {
    if(updateExpenseCharge != "" && updateExpenseContainer != "" && updateExpenseCurrency != "" && updateExpenseCollection != "" && updateExpense != ""){
      setEnableUpdateTerminalExpense(true)
    }
    else{
      setEnableUpdateTerminalExpense(false)
    } 
  }, [updateExpenseCharge, updateExpenseContainer, updateExpenseCurrency, updateExpenseCollection, updateExpense]);

  const updateTerminalExpense = async (e) => {
    e.preventDefault();
    setShowUpdateTerminalExpenseLoader(true)

    const id = updateExpenseId

    const data = {
      charge: updateExpenseCharge,
      product: updateExpenseContainer,
      currency: updateExpenseCurrency,
      collection: updateExpenseCollection,
      expense: updateExpense,
      default_charge: updateIsDefault,
      status: updateStatus,
      modified_by: JSON.stringify(props.loggedInUser)
    }

    const response = await axios.put(process.env.REACT_APP_BACKEND_API_URL+'/user/terminalexpense/'+id+'/', data,  
      {
        headers: { 'content-type': 'application/json'}
      }
    );

    if (response.status === 200 ) {
      toast.success("Terminal Expense Updated Successfully")
      setUpdateExpenseCharge("")
      setUpdateExpenseContainer("")
      setUpdateExpenseCurrency("")
      setUpdateExpenseCollection("")
      setUpdateExpense("")
      setUpdateIsDefault("")
      setUpdateStatus("ACTIVE")
    }

    setShowUpdateTerminalExpenseForm(false)
    fetchTerminalData(props)
    setShowUpdateTerminalExpenseLoader(false)    
  }

  const deleteTerminalExpense = async (id) => {
    setShowDeleteTerminalExpenseLoader(true)
    try {
        await axios.delete(process.env.REACT_APP_BACKEND_API_URL+'/user/terminalexpense/'+id+'/');
        setShowDeleteTerminalExpenseModal(false)
        toast.success("Record deleted successfully")
    } catch (err) {
        toast.error("Error in deleting record! Try again.");
    }
    fetchTerminalData(props)
    setShowDeleteTerminalExpenseLoader(false)
    setShowDeleteTerminalExpenseModal(false)
  }

  if (loading)
    return (
      <div className="text-center my-4">
        <Spinner animation="border" role="status" className="text-inox-green" />
      </div>
    );

  return (
    <div className="row" style={{ paddingLeft: 60 }}>
      <ToastContainer></ToastContainer>

      {/* -------------------------------------------- Terminal Vendors -------------------------------------------- */}
      <div className="col-6" style={{ borderLeft: '0.5px solid lightgrey', borderRight: '0.5px solid lightgrey'}}>
        <div className="row mt-5">
          <div className="col-6 text-left"><h5 className="m-0">Terminal Vendors</h5></div>
          <div className="col-6 text-right">
            {!showAddTerminalVendorForm && !showUpdateTerminalVendorForm?
            <Button className="btn btn-inox-green btn-sm border-0" onClick={() => handleAddTerminalVendorForm()}>Add Vendor</Button>
            :
            <Button className="btn btn-secondary btn-sm border-0 px-4" onClick={() => handleCloseTerminalVendorForm()}>Close</Button>
            }
          </div>
        </div>

        <div className="row text-left">
          {showAddTerminalVendorForm?
            <form ref={addterminalvendorform} onSubmit={(e) => addNewTerminalVendor(e)}>
              <div className="row">
                <div class={`form-group col-4 text-left mb-2`}>
                  <label for="name">Name: <i className="text-danger">*</i><span className="text-danger">{showVendorNameError?" Name required":""}</span></label>
                  <input type="text" className="form-control form-control-sm" id="name" name="name" placeholder="Enter Name" value={vendorName} onChange={(e) => setVendorName(e.target.value)}
                       onBlur={(e) => e.target.value==""?setShowVendorNameError(true):setShowVendorNameError(false)}/>
                </div>

                <div class={`form-group col-4 text-left mb-2`}>
                  <label for="company">Company: <i className="text-danger">*</i><span className="text-danger">{showVendorCompanyError?" Company Name required":""}</span></label>
                  <input type="text" className="form-control form-control-sm" id="company" name="company" placeholder="Enter Company Name" value={vendorCompany} onChange={(e) => setVendorCompany(e.target.value)}
                       onBlur={(e) => e.target.value==""?setShowVendorCompanyError(true):setShowVendorCompanyError(false)}/>
                </div>

                <div class={`form-group col-4 text-left mb-2`}>
                  <label for="address_line_1">Address Line 1: <i className="text-danger">*</i><span className="text-danger">{showVendorAddressLine1Error?" Address required":""}</span></label>
                  <input type="text" className="form-control form-control-sm" id="address_line_1" name="address_line_1" placeholder="Enter Address" value={vendorAddressLine1} onChange={(e) => setVendorAddressLine1(e.target.value)}
                       onBlur={(e) => e.target.value==""?setShowVendorAddressLine1Error(true):setShowVendorAddressLine1Error(false)}/>
                </div>

                <div class={`form-group col-4 text-left mb-2`}>
                  <label for="address_line_2">Address Line 2:</label>
                  <input type="text" className="form-control form-control-sm" id="address_line_2" name="address_line_2" placeholder="Enter Address" value={vendorAddressLine2} onChange={(e) => setVendorAddressLine2(e.target.value)}/>
                </div>

                <div class={`form-group col-4 text-left mb-2`}>
                  <label for="city">City: <i className="text-danger">*</i><span className="text-danger">{showVendorCityError?" City required":""}</span></label>
                  <input type="text" className="form-control form-control-sm" id="city" name="city" placeholder="Enter City" value={vendorCity} onChange={(e) => setVendorCity(e.target.value)}
                       onBlur={(e) => e.target.value==""?setShowVendorCityError(true):setShowVendorCityError(false)}/>
                </div>

                <div class={`form-group col-4 text-left mb-2`}>
                  <label for="state">State: <i className="text-danger">*</i><span className="text-danger">{showVendorStateError?" State required":""}</span></label>
                  <input type="text" className="form-control form-control-sm" id="state" name="state" placeholder="Enter State" value={vendorState} onChange={(e) => setVendorState(e.target.value)}
                       onBlur={(e) => e.target.value==""?setShowVendorStateError(true):setShowVendorStateError(false)}/>
                </div>

                <div class={`form-group col-4 text-left mb-2`}>
                  <label for="country">Country: <i className="text-danger">*</i><span className="text-danger">{showVendorCountryError?" Country required":""}</span></label>
                  <select className="form-select form-select-sm" id="country" name="country" value={vendorCountry} onChange={(e) => [setVendorCountry(e.target.value), e.target.value == ""?setShowVendorCountryError(true):setShowVendorCountryError(false)]}>
                    <option value="">Select Country</option>
                    {countryData?.map(country => (
                      <option value={country.id}>{country.long_name}</option>
                    ))}
                  </select>
                </div>

                <div class={`form-group col-4 text-left mb-2`}>
                  <label for="pincode">Pincode: <i className="text-danger">*</i><span className="text-danger">{showVendorPincodeError?" Pincode required":""}</span></label>
                  <input type="number" className="form-control form-control-sm" id="pincode" name="pincode" placeholder="Enter Pincode" value={vendorPincode} onChange={(e) => setVendorPincode(e.target.value)}
                       onBlur={(e) => e.target.value==""?setShowVendorPincodeError(true):setShowVendorPincodeError(false)}/>
                </div>

                <div class={`form-group col-4 text-left mb-2`}>
                  <label for="email">Email: <i className="text-danger">*</i><span className="text-danger">{showVendorEmailError?" Email required":""}</span></label>
                  <input type="text" className="form-control form-control-sm" id="email" name="email" placeholder="Enter Email" value={vendorEmail} onChange={(e) => setVendorEmail(e.target.value)}
                       onBlur={(e) => e.target.value==""?setShowVendorEmailError(true):setShowVendorEmailError(false)}/>
                </div>
                
                <div class={`form-group col-4 text-left mb-2`}>
                  <label for="license_number">License Number: <i className="text-danger">*</i><span className="text-danger">{showVendorLicenseNumberError?" License Number required":""}</span></label>
                  <input type="text" className="form-control form-control-sm" id="license_number" name="license_number" placeholder="Enter License Number" value={vendorLicenseNumber} onChange={(e) => setVendorLicenseNumber(e.target.value)}
                       onBlur={(e) => e.target.value==""?setShowVendorLicenseNumberError(true):setShowVendorLicenseNumberError(false)}/>
                </div>

                <div class={`form-group col-4 text-left mb-2`}>
                  <label for="mobile_number">Mobile Number: <i className="text-danger">*</i><span className="text-danger">{showVendorMobileNumberError?" Mobile Number required":""}</span></label>
                  <input type="text" className="form-control form-control-sm" id="mobile_number" name="mobile_number" placeholder="Enter Mobile Number" value={vendorMobileNumber} onChange={(e) => setVendorMobileNumber(e.target.value)}
                       onBlur={(e) => e.target.value==""?setShowVendorMobileNumberError(true):setShowVendorMobileNumberError(false)}/>
                </div>

                <div class={`form-group col-4 text-left mb-2`}>
                  <label for="gst_number">Gst Number: <i className="text-danger">*</i><span className="text-danger">{showVendorGstNumberError?" Gst Number required":""}</span></label>
                  <input type="text" className="form-control form-control-sm" id="gst_number" name="gst_number" placeholder="Enter Gst Number" value={vendorGstNumber} onChange={(e) => setVendorGstNumber(e.target.value)}
                       onBlur={(e) => e.target.value==""?setShowVendorGstNumberError(true):setShowVendorGstNumberError(false)}/>
                </div>

                <div class={`form-group col-4 text-left mb-2`}>
                  <label for="pan_number">Pan Number: <i className="text-danger">*</i><span className="text-danger">{showVendorPanNumberError?" Pan Number required":""}</span></label>
                  <input type="text" className="form-control form-control-sm" id="pan_number" name="pan_number" placeholder="Enter Pan Number" value={vendorPanNumber} onChange={(e) => setVendorPanNumber(e.target.value)}
                       onBlur={(e) => e.target.value==""?setShowVendorPanNumberError(true):setShowVendorPanNumberError(false)}/>
                </div>

                <div class={`form-group col-4 text-left mb-2`}></div>

                <div class={`form-group col-4 text-right`}>
                  <Button className="btn btn-sm btn-inox-green border-0 mt-4" onClick={(e) => addNewTerminalVendor(e)} 
                    disabled={enableAddTerminalVendor?false:true}>
                    {showAddTerminalVendorLoader?
                      <Spinner className="mx-5" as="span" animation="border" size="sm" role="status" aria-hidden="true"/>
                      :
                      "Add Vendor"
                    }
                    
                  </Button>
                </div>
              </div>
            </form>
            :
            showUpdateTerminalVendorForm?
            <form onSubmit={(e) => updateTerminalVendor(e)}>
              <div className="row">
                <div class={`form-group col-4 text-left mb-2`}>
                  <label for="name">Name: <i className="text-danger">*</i><span className="text-danger">{showUpdateVendorNameError?" Name required":""}</span></label>
                  <input type="text" className="form-control form-control-sm" id="name" name="name" placeholder="Enter Name" value={updateVendorName} onChange={(e) => setUpdateVendorName(e.target.value)}
                       onBlur={(e) => e.target.value==""?setShowUpdateVendorNameError(true):setShowUpdateVendorNameError(false)}/>
                </div>

                <div class={`form-group col-4 text-left mb-2`}>
                  <label for="company">Company: <i className="text-danger">*</i><span className="text-danger">{showUpdateVendorCompanyError?" Company Name required":""}</span></label>
                  <input type="text" className="form-control form-control-sm" id="company" name="company" placeholder="Enter Company Name" value={updateVendorCompany} onChange={(e) => setUpdateVendorCompany(e.target.value)}
                       onBlur={(e) => e.target.value==""?setShowUpdateVendorCompanyError(true):setShowUpdateVendorCompanyError(false)}/>
                </div>

                <div class={`form-group col-4 text-left mb-2`}>
                  <label for="address_line_1">Address Line 1: <i className="text-danger">*</i><span className="text-danger">{showUpdateVendorAddressLine1Error?" Address required":""}</span></label>
                  <input type="text" className="form-control form-control-sm" id="address_line_1" name="address_line_1" placeholder="Enter Address" value={updateVendorAddressLine1} onChange={(e) => setUpdateVendorAddressLine1(e.target.value)}
                       onBlur={(e) => e.target.value==""?setShowUpdateVendorAddressLine1Error(true):setShowUpdateVendorAddressLine1Error(false)}/>
                </div>

                <div class={`form-group col-4 text-left mb-2`}>
                  <label for="address_line_2">Address Line 2:</label>
                  <input type="text" className="form-control form-control-sm" id="address_line_2" name="address_line_2" placeholder="Enter Address" value={updateVendorAddressLine2} onChange={(e) => setUpdateVendorAddressLine2(e.target.value)}/>
                </div>

                <div class={`form-group col-4 text-left mb-2`}>
                  <label for="city">City: <i className="text-danger">*</i><span className="text-danger">{showUpdateVendorCityError?" City required":""}</span></label>
                  <input type="text" className="form-control form-control-sm" id="city" name="city" placeholder="Enter City" value={updateVendorCity} onChange={(e) => setUpdateVendorCity(e.target.value)}
                       onBlur={(e) => e.target.value==""?setShowUpdateVendorCityError(true):setShowUpdateVendorCityError(false)}/>
                </div>

                <div class={`form-group col-4 text-left mb-2`}>
                  <label for="state">State: <i className="text-danger">*</i><span className="text-danger">{showUpdateVendorStateError?" State required":""}</span></label>
                  <input type="text" className="form-control form-control-sm" id="state" name="state" placeholder="Enter State" value={updateVendorState} onChange={(e) => setUpdateVendorState(e.target.value)}
                       onBlur={(e) => e.target.value==""?setShowUpdateVendorStateError(true):setShowUpdateVendorStateError(false)}/>
                </div>

                <div class={`form-group col-4 text-left mb-2`}>
                  <label for="country">Country: <i className="text-danger">*</i><span className="text-danger">{showUpdateVendorCountryError?" Country required":""}</span></label>
                  <select className="form-select form-select-sm" id="country" name="country" value={updateVendorCountry} onChange={(e) => [setUpdateVendorCountry(e.target.value), e.target.value == ""?setShowUpdateVendorCountryError(true):setShowUpdateVendorCountryError(false)]}>
                    <option value="">Select Country</option>
                    {countryData?.map(country => (
                      <option value={country.id} selected={updateVendorCountry==country.id?true:false}>{country.long_name}</option>
                    ))}
                  </select>
                </div>

                <div class={`form-group col-4 text-left mb-2`}>
                  <label for="pincode">Pincode: <i className="text-danger">*</i><span className="text-danger">{showUpdateVendorPincodeError?" Pincode required":""}</span></label>
                  <input type="number" className="form-control form-control-sm" id="pincode" name="pincode" placeholder="Enter Pincode" value={updateVendorPincode} onChange={(e) => setUpdateVendorPincode(e.target.value)}
                       onBlur={(e) => e.target.value==""?setShowUpdateVendorPincodeError(true):setShowUpdateVendorPincodeError(false)}/>
                </div>

                <div class={`form-group col-4 text-left mb-2`}>
                  <label for="email">Email: <i className="text-danger">*</i><span className="text-danger">{showUpdateVendorEmailError?" Email required":""}</span></label>
                  <input type="text" className="form-control form-control-sm" id="email" name="email" placeholder="Enter Email" value={updateVendorEmail} onChange={(e) => setUpdateVendorEmail(e.target.value)}
                       onBlur={(e) => e.target.value==""?setShowUpdateVendorEmailError(true):setShowUpdateVendorEmailError(false)}/>
                </div>
                
                <div class={`form-group col-4 text-left mb-2`}>
                  <label for="license_number">License Number: <i className="text-danger">*</i><span className="text-danger">{showUpdateVendorLicenseNumberError?" License Number required":""}</span></label>
                  <input type="text" className="form-control form-control-sm" id="license_number" name="license_number" placeholder="Enter License Number" value={updateVendorLicenseNumber} onChange={(e) => setUpdateVendorLicenseNumber(e.target.value)}
                       onBlur={(e) => e.target.value==""?setShowUpdateVendorLicenseNumberError(true):setShowUpdateVendorLicenseNumberError(false)}/>
                </div>

                <div class={`form-group col-4 text-left mb-2`}>
                  <label for="mobile_number">Mobile Number: <i className="text-danger">*</i><span className="text-danger">{showUpdateVendorMobileNumberError?" Mobile Number required":""}</span></label>
                  <input type="text" className="form-control form-control-sm" id="mobile_number" name="mobile_number" placeholder="Enter Mobile Number" value={updateVendorMobileNumber} onChange={(e) => setUpdateVendorMobileNumber(e.target.value)}
                       onBlur={(e) => e.target.value==""?setShowUpdateVendorMobileNumberError(true):setShowUpdateVendorMobileNumberError(false)}/>
                </div>

                <div class={`form-group col-4 text-left mb-2`}>
                  <label for="gst_number">Gst Number: <i className="text-danger">*</i><span className="text-danger">{showUpdateVendorGstNumberError?" Gst Number required":""}</span></label>
                  <input type="text" className="form-control form-control-sm" id="gst_number" name="gst_number" placeholder="Enter Gst Number" value={updateVendorGstNumber} onChange={(e) => setUpdateVendorGstNumber(e.target.value)}
                       onBlur={(e) => e.target.value==""?setShowUpdateVendorGstNumberError(true):setShowUpdateVendorGstNumberError(false)}/>
                </div>

                <div class={`form-group col-4 text-left mb-2`}>
                  <label for="pan_number">Pan Number: <i className="text-danger">*</i><span className="text-danger">{showUpdateVendorPanNumberError?" Pan Number required":""}</span></label>
                  <input type="text" className="form-control form-control-sm" id="pan_number" name="pan_number" placeholder="Enter Pan Number" value={updateVendorPanNumber} onChange={(e) => setUpdateVendorPanNumber(e.target.value)}
                       onBlur={(e) => e.target.value==""?setShowUpdateVendorPanNumberError(true):setShowUpdateVendorPanNumberError(false)}/>
                </div>

                <div class={`form-group col-4 text-left mb-2`}></div>

                <div class={`form-group col-4 text-right`}>
                  <Button className="btn btn-sm btn-inox-green border-0 mt-4" onClick={(e) => updateTerminalVendor(e)}
                    disabled={enableUpdateTerminalVendor?false:true}>
                    {showUpdateTerminalVendorLoader?
                      <Spinner className="mx-5" as="span" animation="border" size="sm" role="status" aria-hidden="true"/>
                      :
                      "Update Vendor"
                    }
                    
                  </Button>
                </div>
              </div>
            </form>
            :""
            }
        </div>

        <DataTable
          title=""
          columns={terminalVendorColumns}
          data={vendorData}
          pagination
          highlightOnHover
          dense
          customStyles={userTableCustomStyles}
        />
      </div>

      {/* -------------------------------------------- Terminal Parameters -------------------------------------------- */}

      <div className="col-6" style={{ borderRight: '0.5px solid lightgrey'}}>
        <div className="row mt-5">
          <div className="col-6 text-left"><h5 className="m-0">Terminal Parameters</h5></div>
          <div className="col-6 text-right">
            {!showAddTerminalParameterForm && !showUpdateTerminalParameterForm?
            <Button className="btn btn-inox-green btn-sm border-0" onClick={() => handleAddTerminalParameterForm()}>Add Parameters</Button>
            :
            <Button className="btn btn-secondary btn-sm border-0 px-4" onClick={() => handleCloseTerminalParameterForm()}>Close</Button>
            }
          </div>
        </div>

        <div className="row text-left">
          {showAddTerminalParameterForm?
            <form ref={addterminalparameterform} onSubmit={(e) => addNewTerminalParameter(e)}>
              <div className="row">
                <div class={`form-group col-3 text-left`}>
                  <label for="name">Charge: <i className="text-danger">*</i><span className="text-danger">{showParameterNameError?" Name required":""}</span></label>
                  <select className="form-select form-select-sm" id="name" name="name" value={parameterName} onChange={(e) => [setParameterName(e.target.value), e.target.value == ""?setShowParameterNameError(true):setShowParameterNameError(false)]}>
                    <option value="">Select Name</option>
                    <option value="PORT_FREE_DAYS">PORT FREE DAYS</option>
                  </select>
                </div>

                <div class={`form-group col-3 text-left`}>
                  <label for="cargo_type">Cargo Type: <i className="text-danger">*</i><span className="text-danger">{showParameterCargoTypeError?" Cargo Type required":""}</span></label>
                  <select className="form-select form-select-sm" id="cargo_type" name="cargo_type" value={parameterCargoType} onChange={(e) => [setParameterCargoType(e.target.value), e.target.value == ""?setShowParameterCargoTypeError(true):setShowParameterCargoTypeError(false)]}>
                    <option value="">Select Cargo Type</option>
                    <option value="HAZARDOUS">HAZARDOUS</option>
                    <option value="NON_HAZARDOUS">NON HAZARDOUS</option>
                    <option value="EMPTY">EMPTY</option>
                  </select>
                </div>

                <div class={`form-group col-3 text-left`}>
                  <label for="container">Container: <i className="text-danger">*</i><span className="text-danger">{showParameterContainerError?" Container required":""}</span></label>
                  <select className="form-select form-select-sm" id="container" name="container" value={parameterContainer} onChange={(e) => [setParameterContainer(e.target.value), e.target.value == ""?setShowParameterContainerError(true):setShowParameterContainerError(false)]}>
                    <option value="">Select Container</option>
                    {containerData?.map(container => (
                      <option value={container.id}>{container.product_name}</option>
                    ))}
                  </select>
                </div>
              
                <div class={`form-group col-3 text-left`}>
                  <label for="trade_type">Trade Type: <i className="text-danger">*</i><span className="text-danger">{showParameterTradeTypeError?" Trade Type required":""}</span></label>
                  <select className="form-select form-select-sm" id="trade_type" name="trade_type" value={parameterTradeType} onChange={(e) => [setParameterTradeType(e.target.value), e.target.value == ""?setShowParameterTradeTypeError(true):setShowParameterTradeTypeError(false)]}>
                    <option value="">Select Trade Type</option>
                    <option value="IMPORT">IMPORT</option>
                    <option value="EXPORT">EXPORT</option>
                  </select>
                </div>
              </div>

              <div className="row mt-3">
                <div class={`form-group col-3 text-left`}>
                  <label for="terminal_in_out_mode">In-Out Mode: <i className="text-danger">*</i><span className="text-danger">{showParameterInOutModeError?" Mode required":""}</span></label>
                  <select className="form-select form-select-sm" id="terminal_in_out_mode" name="terminal_in_out_mode" value={parameterInOutMode} onChange={(e) => [setParameterInOutMode(e.target.value), e.target.value == ""?setShowParameterInOutModeError(true):setShowParameterInOutModeError(false)]}>
                    <option value="">Select Mode</option>
                    <option value="RAIL">RAIL</option>
                    <option value="ROAD">ROAD</option>
                  </select>
                </div>

                <div class={`form-group col-3 text-left`}>
                  <label for="free_days">Free Days: <i className="text-danger">*</i><span className="text-danger">{showParameterFreeDaysError?" Days required":""}</span></label>
                  <input type="number" className="form-control form-control-sm" id="free_days" name="free_days" placeholder="Enter Days" value={parameterFreeDays} onChange={(e) => setParameterFreeDays(e.target.value)}
                       onBlur={(e) => e.target.value==""?setShowParameterFreeDaysError(true):setShowParameterFreeDaysError(false)}/>
                </div>
                
                <div class={`form-group col-3 text-left`}>
                  <label for="status">Status: </label>
                  <select className="form-select form-select-sm" id="status" name="status">
                    <option value="ACTIVE">ACTIVE</option>
                    <option value="INACTIVE">INACTIVE</option>
                  </select>
                </div>

                <div class={`form-group col-3 text-right`}>
                  <Button className="btn btn-sm btn-inox-green border-0 mt-4" onClick={(e) => addNewTerminalParameter(e)} 
                    disabled={enableAddTerminalParameter?false:true}>
                    {showAddTerminalParameterLoader?
                      <Spinner className="mx-5" as="span" animation="border" size="sm" role="status" aria-hidden="true"/>
                      :
                      "Add Param"
                    }
                    
                  </Button>
                </div>
              </div>
            </form>
            :
            showUpdateTerminalParameterForm?
            <form onSubmit={(e) => updateTerminalParameter(e)}>
              <div className="row">
                <div class={`form-group col-3 text-left`}>
                  <label for="name">Charge: <i className="text-danger">*</i><span className="text-danger">{showUpdateParameterNameError?" Name required":""}</span></label>
                  <select className="form-select form-select-sm" id="name" name="name" value={updateParameterName} onChange={(e) => [setUpdateParameterName(e.target.value), e.target.value == ""?setShowUpdateParameterNameError(true):setShowUpdateParameterNameError(false)]}>
                    <option value="">Select Name</option>
                    <option value="PORT_FREE_DAYS" selected={updateParameterName=="PORT_FREE_DAYS"?true:false}>PORT FREE DAYS</option>
                  </select>
                </div>

                <div class={`form-group col-3 text-left`}>
                  <label for="cargo_type">Cargo Type: <i className="text-danger">*</i><span className="text-danger">{showUpdateParameterCargoTypeError?" Cargo Type required":""}</span></label>
                  <select className="form-select form-select-sm" id="cargo_type" name="cargo_type" value={updateParameterCargoType} onChange={(e) => [setUpdateParameterCargoType(e.target.value), e.target.value == ""?setShowUpdateParameterCargoTypeError(true):setShowUpdateParameterCargoTypeError(false)]}>
                    <option value="">Select Cargo Type</option>
                    <option value="HAZARDOUS" selected={updateParameterCargoType=="HAZARDOUS"?true:false}>HAZARDOUS</option>
                    <option value="NON_HAZARDOUS" selected={updateParameterCargoType=="NON_HAZARDOUS"?true:false}>NON HAZARDOUS</option>
                    <option value="EMPTY" selected={updateParameterCargoType=="EMPTY"?true:false}>EMPTY</option>
                  </select>
                </div>

                <div class={`form-group col-3 text-left`}>
                  <label for="container">Container: <i className="text-danger">*</i><span className="text-danger">{showUpdateParameterContainerError?" Container required":""}</span></label>
                  <select className="form-select form-select-sm" id="container" name="container" value={updateParameterContainer} onChange={(e) => [setUpdateParameterContainer(e.target.value), e.target.value == ""?setShowUpdateParameterContainerError(true):setShowUpdateParameterContainerError(false)]}>
                    <option value="">Select Container</option>
                    {containerData?.map(container => (
                      <option value={container.id} selected={updateParameterContainer==container.id?true:false}>{container.product_name}</option>
                    ))}
                  </select>
                </div>

                <div class={`form-group col-3 text-left`}>
                  <label for="trade_type">Trade Type: <i className="text-danger">*</i><span className="text-danger">{showUpdateParameterTradeTypeError?" Trade Type required":""}</span></label>
                  <select className="form-select form-select-sm" id="trade_type" name="trade_type" value={updateParameterTradeType} onChange={(e) => [setUpdateParameterTradeType(e.target.value), e.target.value == ""?setShowUpdateParameterTradeTypeError(true):setShowUpdateParameterTradeTypeError(false)]}>
                    <option value="">Select Trade Type</option>
                    <option value="IMPORT" selected={updateParameterTradeType=="IMPORT"?true:false}>IMPORT</option>
                    <option value="EXPORT" selected={updateParameterTradeType=="EXPORT"?true:false}>EXPORT</option>
                  </select>
                </div>
              </div>

              <div className="row mt-3">
                <div class={`form-group col-3 text-left`}>
                  <label for="terminal_in_out_mode">In-Out Mode: <i className="text-danger">*</i><span className="text-danger">{showUpdateParameterInOutModeError?" Mode required":""}</span></label>
                  <select className="form-select form-select-sm" id="terminal_in_out_mode" name="terminal_in_out_mode" value={updateParameterInOutMode} onChange={(e) => [setUpdateParameterInOutMode(e.target.value), e.target.value == ""?setShowUpdateParameterInOutModeError(true):setShowUpdateParameterInOutModeError(false)]}>
                    <option value="">Select Mode</option>
                    <option value="RAIL" selected={updateParameterInOutMode=="RAIL"?true:false}>RAIL</option>
                    <option value="ROAD" selected={updateParameterInOutMode=="ROAD"?true:false}>ROAD</option>
                  </select>
                </div>

                <div class={`form-group col-3 text-left`}>
                  <label for="free_days">Free Days: <i className="text-danger">*</i><span className="text-danger">{showUpdateParameterFreeDaysError?" Days required":""}</span></label>
                  <input type="number" className="form-control form-control-sm" id="free_days" name="free_days" placeholder="Enter Days" value={updateParameterFreeDays} onChange={(e) => setUpdateParameterFreeDays(e.target.value)}
                       onBlur={(e) => e.target.value==""?setShowUpdateParameterFreeDaysError(true):setShowUpdateParameterFreeDaysError(false)}/>
                </div>
                
                <div class={`form-group col-3 text-left`}>
                  <label for="status">Status: </label>
                  <select className="form-select form-select-sm" id="status" name="status" onChange={(e) => setUpdateParameterStatus(e.target.value)}>
                    <option value="ACTIVE" selected={updateParameterStatus=="ACTIVE"?true:false}>ACTIVE</option>
                    <option value="INACTIVE" selected={updateParameterStatus=="INACTIVE"?true:false}>INACTIVE</option>
                  </select>
                </div>

                <div class={`form-group col-3 text-left`}>
                  <Button className="btn btn-sm btn-inox-green border-0 mt-4" onClick={(e) => updateTerminalParameter(e)}
                    disabled={enableUpdateTerminalParameter?false:true}>
                    {showUpdateTerminalParameterLoader?
                      <Spinner className="mx-5" as="span" animation="border" size="sm" role="status" aria-hidden="true"/>
                      :
                      "Update Param"
                    }
                    
                  </Button>
                </div>
              </div>
            </form>
            :""
            }
        </div>

        <DataTable
          title=""
          columns={terminalParamColumns}
          data={paramData}
          pagination
          highlightOnHover
          dense
          customStyles={userTableCustomStyles}
        />
      </div>

      {/* -------------------------------------------- Terminal Expenses -------------------------------------------- */}
      <div className="col-12" style={{ borderLeft: '0.5px solid lightgrey', borderRight: '0.5px solid lightgrey', borderTop: '0.5px solid lightgrey'}}>
        <div className="row mt-5">
          <div className="col-6 text-left"><h5 className="m-0">Terminal Expenses</h5></div>
          <div className="col-6 text-right">
            {!showAddTerminalExpenseForm && !showUpdateTerminalExpenseForm?
            <Button className="btn btn-inox-green btn-sm border-0" onClick={() => handleAddTerminalExpenseForm()}>Add Expense</Button>
            :
            <Button className="btn btn-secondary btn-sm border-0 px-4" onClick={() => handleCloseTerminalExpenseForm()}>Close</Button>
            }
          </div>
        </div>
        <div className="row text-left">
          {showAddTerminalExpenseForm?
            <form ref={addterminalexpenseform} onSubmit={(e) => addNewTerminalExpense(e)}>
              <div className="row">
                <div class={`form-group col-2 text-left`}>
                  <label for="charge">Charge: <i className="text-danger">*</i><span className="text-danger">{showExpenseChargeError?" Charge required":""}</span></label>
                  <select className="form-select form-select-sm" id="charge" name="charge" value={expenseCharge} onChange={(e) => [setExpenseCharge(e.target.value), e.target.value == ""?setShowExpenseChargeError(true):setShowExpenseChargeError(false)]}>
                    <option value="">Select Charge</option>
                    {chargeData?.map(charge => (
                      <option value={charge.id}>{charge.name}</option>
                    ))}
                  </select>
                </div>

                <div class={`form-group col-2 text-left`}>
                  <label for="container">Container: <i className="text-danger">*</i><span className="text-danger">{showExpenseContainerError?" Container required":""}</span></label>
                  <select className="form-select form-select-sm" id="container" name="container" value={expenseContainer} onChange={(e) => [setExpenseContainer(e.target.value), e.target.value == ""?setShowExpenseContainerError(true):setShowExpenseContainerError(false)]}>
                    <option value="">Select Container</option>
                    {containerData?.map(container => (
                      <option value={container.id}>{container.product_name}</option>
                    ))}
                  </select>
                </div>

                <div class={`form-group col-2 text-left`}>
                  <label for="collection">Colection: <i className="text-danger">*</i><span className="text-danger">{showExpenseCollectionError?" Amount required":""}</span></label>
                  <input type="number" className="form-control form-control-sm" id="collection" name="collection" placeholder="Enter Amount" value={expenseCollection} onChange={(e) => setExpenseCollection(e.target.value)}
                       onBlur={(e) => e.target.value==""?setShowExpenseCollectionError(true):setShowExpenseCollectionError(false)}/>
                </div>

                <div class={`form-group col-2 text-left`}>
                  <label for="expense">Expense: <i className="text-danger">*</i><span className="text-danger">{showExpenseError?" Amount required":""}</span></label>
                  <input type="number" className="form-control form-control-sm" id="expense" name="expense" placeholder="Enter Amount"  value={expense} onChange={(e) => setExpense(e.target.value)}
                         onBlur={(e) => e.target.value==""?setShowExpenseError(true):setShowExpenseError(false)}/>
                </div>

                <div class={`form-group col-1 text-left`}>
                  <label for="currency">Currency: <i className="text-danger">*</i><span className="text-danger">{showExpenseCurrencyError?" Currency required":""}</span></label>
                  <select className="form-select form-select-sm" id="currency" name="currency" value={expenseCurrency} onChange={(e) => [setExpenseCurrency(e.target.value), e.target.value == ""?setShowExpenseCurrencyError(true):setShowExpenseCurrencyError(false)]}>
                    <option value="">Select Currency</option>
                    {currencyData?.map(currency => (
                      <option value={currency.id}>{currency.name}</option>
                    ))}
                  </select>
                </div>

                <div class={`form-group col-1 text-left`}>
                  <label for="is_default_expense">Is Default: </label>
                  <select className="form-select form-select-sm" id="is_default_expense" name="is_default_expense">
                    <option value="NO">NO</option>
                    <option value="YES">YES</option>
                  </select>
                </div>
                
                <div class={`form-group col-1 text-left`}>
                  <label for="status">Status: </label>
                  <select className="form-select form-select-sm" id="status" name="status">
                    <option value="ACTIVE">ACTIVE</option>
                    <option value="INACTIVE">INACTIVE</option>
                  </select>
                </div>

                <div class={`form-group col-1 text-right`}>
                  <Button className="btn btn-sm btn-inox-green border-0 mt-4" onClick={(e) => addNewTerminalExpense(e)} 
                    disabled={enableAddTerminalExpense?false:true}>
                    {showAddTerminalExpenseLoader?
                      <Spinner className="mx-5" as="span" animation="border" size="sm" role="status" aria-hidden="true"/>
                      :
                      "Add Expense"
                    }
                    
                  </Button>
                </div>
              </div>
            </form>
            :
            showUpdateTerminalExpenseForm?
            <form onSubmit={(e) => updateTerminalExpense(e)}>
              <div className="row">
                <div class={`form-group col-2 text-left`}>
                  <label for="charge">Charge: <i className="text-danger">*</i><span className="text-danger">{showUpdateExpenseChargeError?" Charge required":""}</span></label>
                  <select className="form-select form-select-sm" id="charge" name="charge" onChange={(e) => [setUpdateExpenseCharge(e.target.value), e.target.value == ""?setShowUpdateExpenseChargeError(true):setShowUpdateExpenseChargeError(false)]}>
                    <option value="">Select Charge</option>
                    {chargeData?.map(charge => (
                      <option value={charge.id} selected={updateExpenseCharge==charge.id?true:false}>{charge.name}</option>
                    ))}
                  </select>
                </div>

                <div class={`form-group col-2 text-left`}>
                  <label for="container">Container: <i className="text-danger">*</i><span className="text-danger">{showUpdateExpenseContainerError?" Container required":""}</span></label>
                  <select className="form-select form-select-sm" id="container" name="container" onChange={(e) => [setUpdateExpenseContainer(e.target.value), e.target.value == ""?setShowUpdateExpenseContainerError(true):setShowUpdateExpenseContainerError(false)]}>
                    <option value="">Select Container</option>
                    {containerData?.map(container => (
                      <option value={container.id} selected={updateExpenseContainer==container.id?true:false}>{container.product_name}</option>
                    ))}
                  </select>
                </div>

                <div class={`form-group col-2 text-left`}>
                  <label for="collection">Colection: <i className="text-danger">*</i><span className="text-danger">{showUpdateExpenseCollectionError?" Amount required":""}</span></label>
                  <input type="number" 
                        className="form-control form-control-sm" 
                        id="collection" 
                        name="collection" 
                        placeholder="Enter Amount" 
                        value={updateExpenseCollection} 
                        onChange={(e) => setUpdateExpenseCollection(e.target.value)} 
                        onBlur={(e) => e.target.value==""?setShowUpdateExpenseCollectionError(true):setShowUpdateExpenseCollectionError(false)}
                  />
                </div>

                <div class={`form-group col-2 text-left`}>
                  <label for="expense">Expense: <i className="text-danger">*</i><span className="text-danger">{showUpdateExpenseError?" Amount required":""}</span></label>
                  <input type="number" className="form-control form-control-sm" id="expense" name="expense" placeholder="Enter Amount" 
                        value={updateExpense} onChange={(e) => setUpdateExpense(e.target.value)} onBlur={(e) => e.target.value==""?setShowUpdateExpenseError(true):setShowUpdateExpenseError(false)}/>
                </div>

                <div class={`form-group col-1 text-left`}>
                  <label for="currency">Currency: <i className="text-danger">*</i><span className="text-danger">{showUpdateExpenseCurrencyError?" Currency required":""}</span></label>
                  <select className="form-select form-select-sm" id="currency" name="currency" onChange={(e) => [setUpdateExpenseCurrency(e.target.value), e.target.value == ""?setShowUpdateExpenseCurrencyError(true):setShowUpdateExpenseCurrencyError(false)]}>
                    <option value="">Select Currency</option>
                    {currencyData?.map(currency => (
                      <option value={currency.id} selected={updateExpenseCurrency==currency.id?true:false}>{currency.name}</option>
                    ))}
                  </select>
                </div>

                <div class={`form-group col-1 text-left`}>
                  <label for="is_default_expense">Is Default: </label>
                  <select className="form-select form-select-sm" id="is_default_expense" name="is_default_expense" onChange={(e) => setUpdateIsDefault(e.target.value)}>
                    <option value="NO" selected={updateIsDefault=="NO"?true:false}>NO</option>
                    <option value="YES" selected={updateIsDefault=="YES"?true:false}>YES</option>
                  </select>
                </div>
                
                <div class={`form-group col-1 text-left`}>
                  <label for="status">Status: </label>
                  <select className="form-select form-select-sm" id="status" name="status" onChange={(e) => setUpdateStatus(e.target.value)}>
                    <option value="ACTIVE" selected={updateStatus=="ACTIVE"?true:false}>ACTIVE</option>
                    <option value="INACTIVE" selected={updateStatus=="INACTIVE"?true:false}>INACTIVE</option>
                  </select>
                </div>

                <div class={`form-group col-1 text-left`}>
                  <Button className="btn btn-sm btn-inox-green border-0 mt-4" onClick={(e) => updateTerminalExpense(e)}
                    disabled={enableUpdateTerminalExpense?false:true}>
                    {showUpdateTerminalExpenseLoader?
                      <Spinner className="mx-5" as="span" animation="border" size="sm" role="status" aria-hidden="true"/>
                      :
                      "Update Expense"
                    }
                    
                  </Button>
                </div>
              </div>
            </form>
            :""
            }
        </div>

        <DataTable
          title=""
          columns={terminalExpenseColumns}
          data={expenseData}
          pagination
          highlightOnHover
          dense
          customStyles={userTableCustomStyles}
        />
      </div>


      <Modal size="sm" show={showDeleteTerminalVendorModal} onHide={() => setShowDeleteTerminalVendorModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Delete</Modal.Title>
        </Modal.Header>
        <Modal.Body>Do you want to delete this record?</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowDeleteTerminalVendorModal(false)}>Close</Button>
          <Button variant="danger" onClick={()=> deleteTerminalVendor(updateVendorId)}>
            {showDeleteTerminalVendorLoader?
            <Spinner className="mx-3 text-white" as="span" animation="border" size="sm" role="status" aria-hidden="true"/>
            :
            "Delete"
            }
            
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal size="sm" show={showDeleteTerminalParameterModal} onHide={() => setShowDeleteTerminalParameterModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Delete</Modal.Title>
        </Modal.Header>
        <Modal.Body>Do you want to delete this record?</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowDeleteTerminalParameterModal(false)}>Close</Button>
          <Button variant="danger" onClick={()=> deleteTerminalParameter(updateParameterId)}>
            {showDeleteTerminalParameterLoader?
            <Spinner className="mx-3 text-white" as="span" animation="border" size="sm" role="status" aria-hidden="true"/>
            :
            "Delete"
            }
            
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal size="sm" show={showDeleteTerminalExpenseModal} onHide={() => setShowDeleteTerminalExpenseModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Delete</Modal.Title>
        </Modal.Header>
        <Modal.Body>Do you want to delete this record?</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowDeleteTerminalExpenseModal(false)}>Close</Button>
          <Button variant="danger" onClick={()=> deleteTerminalExpense(updateExpenseId)}>
            {showDeleteTerminalExpenseLoader?
            <Spinner className="mx-3 text-white" as="span" animation="border" size="sm" role="status" aria-hidden="true"/>
            :
            "Delete"
            }
            
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default ExpandableTerminalComponent;
